/**
 * The SWAYM Way Controller (the-swaym-way.js)
 * Fade-up reveal (section, info card, staggered feature icons) via
 * IntersectionObserver, plus a subtle scroll parallax on the arched image.
 * No animation library required.
 */

(function () {
  function initFeatureStagger(section) {
    const features = section.querySelectorAll('.tsw-feature');
    features.forEach((feature, index) => {
      feature.style.setProperty('--tsw-feature-delay', `${0.3 + index * 0.15}s`);
    });
  }

  function initReveal(section, prefersReducedMotion) {
    if (prefersReducedMotion || typeof IntersectionObserver === 'undefined') {
      section.classList.add('tsw-in-view');
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.classList.add('tsw-in-view');
            obs.disconnect();
          }
        });
      },
      { threshold: 0.15 }
    );

    observer.observe(section);
    section._tswObserver = observer;
  }

  function initParallax(section, prefersReducedMotion) {
    if (prefersReducedMotion) return;

    const frame = section.querySelector('[data-tsw-parallax]');
    if (!frame) return;

    let ticking = false;

    function update() {
      ticking = false;
      const rect = section.getBoundingClientRect();
      const viewportCenter = window.innerHeight / 2;
      const sectionCenter = rect.top + rect.height / 2;
      const distance = (viewportCenter - sectionCenter) * 0.06;
      const clamped = Math.max(-24, Math.min(24, distance));
      frame.style.transform = `translateY(${clamped}px)`;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    update();
    section._tswParallaxHandler = onScroll;
  }

  function initSection(section) {
    if (section.dataset.tswInitialized === 'true') return;
    section.dataset.tswInitialized = 'true';

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    initFeatureStagger(section);
    initReveal(section, prefersReducedMotion);
    initParallax(section, prefersReducedMotion);
  }

  function destroySection(section) {
    if (section._tswObserver) {
      section._tswObserver.disconnect();
      delete section._tswObserver;
    }
    if (section._tswParallaxHandler) {
      window.removeEventListener('scroll', section._tswParallaxHandler);
      delete section._tswParallaxHandler;
    }
  }

  function initAll() {
    document.querySelectorAll('.tsw-section').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.tsw-section');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('.tsw-section');
    if (section) destroySection(section);
  });
})();
